import {
  get,
  put,
  post,
  del,
  default as com
} from '@/common/api'
import axios from 'axios'
const api = {
  /** ****************** 患者 ****************** **/
  getOrCreatePatientByIdInfo: com.getOrCreatePatientByIdInfo,
  getOrCreatePatientByInsurance: com.getOrCreatePatientByInsurance,
  /** ****************** 读卡 ****************** **/
  readIdCard() {
    return new Promise((resolve, reject) => {
      return axios
        .get(cfg.idCard.url())
        .then(response => (resolve(response.data)))
        .catch(function (error) { // 请求失败处理
          console.log(error);
        });
    })
  },
  readInsuranceCard(medCode, tradeCode, mdtrtCertType, para, mdtrtCertNo = '') {
    return new Promise((resolve, reject) => {
      const url = `${cfg.medCard.url()}/${medCode}/${tradeCode}/${mdtrtCertType}?mdtrtCertNo=${mdtrtCertNo}`
      return axios
        .get(url, {
          params: para
        })
        .then(response => (resolve(response.data)))
        .catch(function (error) { // 请求失败处理
          reject(error)
          console.log(error);
        });
      // com.getPatientByIdNo('110105197402126126').then(res => {
      //   resolve(res)
      // })
    })
  },
  readInsuranceCardInjury() {
    return new Promise((resolve, reject) => {
      com.getPatientByIdNo('110105197002116116').then(res => {
        res.injuries = [{
          id: 112255,
          time: '2020-12-25',
          proces: '工作时跌倒',
          partordisease: '左膝粉碎性骨折'
        }, {
          id: 112659,
          time: '2020-12-25',
          proces: '工作时跌倒',
          partordisease: '右膝粉碎性骨折'
        }, ]
        resolve(res)
      })
    })
  }
}

export default api
